/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ApiService } from './services/api.service';
import { SystemFormsInternalV2Service } from './services/system-forms-internal-v-2.service';
import { MembersInternalV2Service } from './services/members-internal-v-2.service';
import { SubmissionsCycleInternalV2Service } from './services/submissions-cycle-internal-v-2.service';
import { AuthService } from './services/auth.service';
import { MembersV2Service } from './services/members-v-2.service';
import { MembersSecretariatV2Service } from './services/members-secretariat-v-2.service';
import { SubmissionsV2Service } from './services/submissions-v-2.service';
import { SubmissionsSecretariatV2Service } from './services/submissions-secretariat-v-2.service';
import { SystemFormsV2Service } from './services/system-forms-v-2.service';
import { SubmissionsCycleV2Service } from './services/submissions-cycle-v-2.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ApiService,
    SystemFormsInternalV2Service,
    MembersInternalV2Service,
    SubmissionsCycleInternalV2Service,
    AuthService,
    MembersV2Service,
    MembersSecretariatV2Service,
    SubmissionsV2Service,
    SubmissionsSecretariatV2Service,
    SystemFormsV2Service,
    SubmissionsCycleV2Service,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
